import styled from 'styled-components';

export const StyledDeletedCompanyGroups = styled.div`
    padding: 2rem;
`;
